import { cn } from "@/features/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn(
        "tw-animate-pulse tw-rounded-md tw-bg-slate-100 dark:tw-bg-slate-800",
        className
      )}
      {...props} />
  );
}

export { Skeleton }
